/**
 * JS functions used across the whole system (admin and public)
 */

var springSpace = springSpace || {};
springSpace.la = springSpace.la || {};
springSpace.Util = {};
{
    const selectText = function (element) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
    };

    // @deprecated used in common search js
    const stringFormat = function (str, arr) {
        return str.replace(/%(\d+)/g, function (_, m) {
            return arr[--m];
        });
    };

    springSpace.Util = {
        selectText,
        stringFormat,
    };
}

/**
 * Close a Bootstrap modal
 * BS5: this is overriden in ModalBS5.js so the bs5 version will work
 * @param {String} [modal_id] id of modal div, else will default to a displayed element with class modal
 */
// eslint-disable-next-line no-unused-vars
function closeModal(modal_id) {
    var $modal = null;
    if (typeof modal_id == 'undefined') {
        jQuery('.modal').each(function (i, el) {
            if (jQuery(el).css('display') !== 'none') {
                $modal = jQuery(el);
            }
        });
    } else {
        $modal = jQuery('#' + modal_id);
    }

    if ($modal !== null) {
        // $modal.modal('hide');
        $modal.modal('hide').removeData('bs.modal').find('.modal-content').html('');
    }
}
/**
 * Disables a button
 * @param {String} btnsel selector for button
 */
// eslint-disable-next-line no-unused-vars
function disableButton(btnsel) {
    if (!btnsel) {
        return;
    }
    if (['#', '.'].indexOf(btnsel.charAt(0)) === -1) {
        btnsel = '#' + btnsel;
    }
    jQuery(btnsel).prop('disabled', true);
}
/**
 * reenables a button
 * @param {String} btnsel selector for button
 */
// eslint-disable-next-line no-unused-vars
function enableButton(btnsel) {
    if (!btnsel) {
        return;
    }
    if (['#', '.'].indexOf(btnsel.charAt(0)) === -1) {
        btnsel = '#' + btnsel;
    }
    jQuery(btnsel).prop('disabled', false);
}

/**
 * Notification functions used through the system
 */

var errorAlert = function (msg = '') {
    window.suiNotify.hideWorking();
    window.suiNotify.error(msg);
};
// eslint-disable-next-line no-unused-vars
var successAlert = function (msg = '', ms = 0) {
    window.suiNotify.hideWorking();
    if (msg === '') {
        ms = 5000;
    }
    window.suiNotify.success(msg, null, ms);
};
// eslint-disable-next-line no-unused-vars
var workingAlert = function (msg = '') {
    window.suiNotify.working(msg);
};
/**
 * Hide working alerts only
 */
// eslint-disable-next-line no-unused-vars
var stopAlert = function () {
    window.suiNotify.hideWorking();
};

/**
 * Generic get error message from Response class error.
 * @deprecated prefer version in tools/requestUtil.js when possible
 * @param {Object} jqXhr JQuery xhr object.
 * @returns {String}
 */

var jqGetAjaxError = function (jqXhr) {
    let error = '';
    if (jqXhr.responseText) {
        try {
            const response = JSON.parse(jqXhr.responseText);
            if (response.error) {
                error = response.error;
            }
        } catch {
            error = 'Invalid response received';
        }
    }
    return error;
};
/**
 * Generic fail callback for jQuery ajax requests.
 * This handles the object error genered in the php Response class.
 * @param {Object} jqXhr JQuery xhr object.
 */
// eslint-disable-next-line no-unused-vars
var jqAjaxFailCallback = function (jqXhr) {
    const error = jqGetAjaxError(jqXhr);
    errorAlert(error);
};

/**
 * Create a dismissable error alert for insertion into the DOM.
 * Uses bootstrap.
 * @param {String} message HTML Error message (html)
 * @param {String} id Optional html id for alert.
 * @returns {HTMLElement}
 */
var createDismissableErrorAlert = function (message = '', id = '') {
    if (!message) {
        message = 'Error';
    }
    return createDismissableAlert(message, 'danger', id);
};

/**
 * Create a dismissable success alert for insertion into the DOM.
 * Uses bootstrap.
 * @param {String} message HTML Error message (html)
 * @param {String} id Optional html id for alert.
 * @returns {HTMLElement}
 */
// eslint-disable-next-line no-unused-vars
var createDismissableSuccessAlert = function (message = '', id = '') {
    if (!message) {
        message = 'Success';
    }
    return createDismissableAlert(message, 'success', id);
};

/**
 * Create a dismissable error alert for insertion into the DOM.
 * Message generated from jquery ajax error.
 * Uses bootstrap.
 * @param {Object} jqXhr JQuery xhr object.
 * @returns {HTMLElement}
 */
// eslint-disable-next-line no-unused-vars
var createDismissableJQAjaxFailAlert = function (jqXhr) {
    const error = jqGetAjaxError(jqXhr);
    return createDismissableErrorAlert(error);
};

/**
 * Create a dismissable alert for insertion into the DOM.
 * Uses bootstrap.
 * @param {String} message HTML Error message (html)
 * @param {String} colorClass Bootstrap based (danger, success, info, etc.)
 * @param {String} id Optional html id for alert.
 * @returns {HTMLElement}
 */
var createDismissableAlert = function (message, colorClass, id = '') {
    var alert = document.createElement('div');
    if (id !== '') {
        alert.id = id;
    }
    alert.classList.add('alert', 'alert-' + colorClass, 'alert-dismissable', 'mg-top');
    alert.setAttribute('role', 'alert');
    alert.setAttribute('aria-atomic', 'true');
    var button = document.createElement('button');
    button.type = 'button';
    button.classList.add('close');
    button.setAttribute('aria-label', 'close');
    button.setAttribute('data-dismiss', 'alert');
    button.innerHTML = '<span aria-hidden="true">&times;</span>';
    alert.appendChild(button);
    alert.insertAdjacentHTML('beforeend', message);
    return alert;
};
